module.exports = __webpack_public_path__ + "img/emision_atmosferica_hover.a490944a.png";